import React, { useState } from 'react';
import no_image from '../assets/no_image.jpg';
import { translate } from '../translations/translations.js';
import { translateCity } from '../translations/cityTranslations.js';
import { applyGrammar } from '../translations/grammarApplier.js';

const excludedLowPopCategories = [
  "artwork", "fountain", "graffiti", "installation", "monument",
  "mosaic", "mural", "painting", "park", "picnic site", "relief", "viewpoint"
];

const statuesCategories = [
  "bust", "sculpture", "statue", "bronze"
];

const POIList = ({ pois, visitedPOIs, language, onSelect }) => {
  return (
    <div className="poi-list">
      {pois.map((poi) => {
        const isSelected = visitedPOIs.includes(poi);
        return (
          <div
            key={poi.poi_id}
            className={`poi-card ${isSelected ? 'selected' : ''}`}
            onClick={() => onSelect(poi)}
          >
            <img
              src={
                poi.photo_blob
                  ? `data:image/jpeg;base64,${poi.photo_blob}`
                  : poi.photo_url || no_image
              }
              className="poi-image"
              loading="lazy"
              onError={(e) => { e.target.src = no_image }}
            />
            <div className="poi-info">
              <div className="poi-text">
                <h3>{language === 'en' ? (poi.name_en || poi.name) : (poi.name_pt || poi.name)}</h3>
                <p>{poi.category}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const filterPOIs = (poiList) => {
  return poiList.filter(poi => {
    const popularity = poi.poi_popularity || 0;
    const hasPhoto = poi.photo_blob !== null;
    const category = (poi.category || "").toLowerCase();


    if (popularity >= 7) {
      if (statuesCategories.includes(category)){
        return hasPhoto;
      }
      return true
    }
    if (statuesCategories.includes(category)){
      return false;
    }

    if (popularity >= 5 && popularity < 7) {
      return hasPhoto;
    }
    if (popularity < 5) {
      return hasPhoto && !excludedLowPopCategories.includes(category);
    }
    return false; 
  });
};

const SelectVisitedPOIsForm = ({ currentCity, pois, language, onNavigate }) => {
  const [visitedPOIs, setVisitedPOIs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handlePOISelect = (poi) => {
    setVisitedPOIs((prev) =>
      prev.includes(poi) ? prev.filter(p_poi => p_poi.poi_id !== poi.poi_id) : [...prev, poi]
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onNavigate(visitedPOIs);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredPOIs = filterPOIs(pois[currentCity["value"]])
    .filter(poi => {
      const name = String((language === 'en' ? poi.name_en : poi.name_pt) || poi.name || "");
      return name.toLowerCase().includes(searchQuery);
    })
    .sort((a, b) => b.poi_popularity - a.poi_popularity);

  return (
    <form className="form-grid" onSubmit={handleSubmit}>
      <header className='form-header'>
        <h1>
          {applyGrammar(
            translate('selectPOIsPrompt', language)
              .replace("X", translateCity(currentCity["name"], language).replace(/\((.*?)\)/g, '$1')),
            language
          )}
        </h1>
        <input
          type="text"
          placeholder={translate('search', language) || "Search..."}
          value={searchQuery}
          onChange={handleSearchChange}
          className="poi-search-input"
        />
      </header>

      <div className="form-container-grid">
        <POIList
          pois={filteredPOIs}
          visitedPOIs={visitedPOIs}
          onSelect={handlePOISelect}
          language={language}
        />
      </div>
      <button type="submit">{translate('submit', language)}</button>
    </form>
  );
};

export default SelectVisitedPOIsForm;
